import { useEffect, useState } from 'react'
import { Controller } from 'react-hook-form'

import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group'

import { FormFieldProps } from './dynamic-input'

export const InputRadio = ({ field, form }: FormFieldProps) => {
  const content = field?.content
  const fieldName = `${field?.id!}`
  const [value, setValue] = useState<string>('')

  // Initialize value from form when component mounts
  useEffect(() => {
    const currentValue = form.getValues(fieldName)
    if (currentValue) {
      setValue(currentValue)
    }
  }, [fieldName, form])

  return (
    <Controller
      control={form.control}
      name={fieldName}
      rules={{
        required: content?.required ? 'Field is required' : false,
      }}
      render={({ field: controllerField }) => (
        <RadioGroup
          onValueChange={(val) => {
            controllerField.onChange(val)
            setValue(val)
          }}
          value={controllerField.value || value}
        >
          {(content?.options || []).map((row) => (
            <div key={row.id} className="flex items-center space-x-2 mb-2">
              <RadioGroupItem
                id={`${fieldName}-${row.id!}`}
                value={String(row.label)}
              />
              <label
                htmlFor={`${fieldName}-${row.id!}`}
                className="text-sm font-medium cursor-pointer"
              >
                {row.label}
              </label>
            </div>
          ))}
        </RadioGroup>
      )}
    />
  )
}
